export default {
  BUTTON_PRIMARY_CLASS: 'btn btn-default',
  BUTTON_SECONDARY_CLASS: 'btn btn-default btn-inverse',

  LOAD_MORE_TEXT: 'VEJA MAIS',

  START_OVER: 'RECOMEÇAR',
  CURRENT_SEARCH: 'Busca atual:',

  FACET_DIALOG_BUTTON_CLASS: 'btn-inverse',
  FACET_DIALOG_RESULTS: 'Resultados',
  FACET_DIALOG_DONE: 'Mostrar {{totalHits}} Resultados',

  PRODUCT_REPEATER_CLASS: 'product-items product-items-4',

  SORT_BY: 'Ordenar por:',
  SHOW_RESULTS: 'Mostrar {{totalHits}} Resultados',

  SEARCH_BOX_PLACEHOLDER: 'Olá, digite o que você procura',
  SEARCH_BOX_FORM_CLASS: "search-form{this.inputNotEmpty ? ' cm_searchInput__clear' : ''}",
  SEARCH_BOX_INPUT_CLASS: 'search-text form-control',
  SEARCH_BOX_BUTTON_CLASS: 'search-submit btn btn-default',
};
